export const BAND = {
  green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  yellow: "bg-amber-50 text-amber-800 ring-amber-200",
  red: "bg-red-50 text-red-700 ring-red-200",
};

export const Band = ({ b, s, id }) => (
  <span data-testid={id} className={`chip border-0 ring-1 uppercase ${BAND[b] || "bg-slate-50 text-slate-600 ring-slate-200"}`}>{b}{s != null ? ` · ${s}` : ""}</span>
);

export const Stat = ({ label, value, sub, id }) => (
  <div className="panel p-4">
    <div className="text-[11px] text-slate-500">{label}</div>
    <div className="num text-2xl font-semibold text-slate-900" data-testid={id}>{value ?? "-"}</div>
    {sub && <div className="text-[10px] text-slate-500 mt-0.5">{sub}</div>}
  </div>
);

export const inputCls = "text-xs rounded-lg border border-slate-200 px-2.5 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200";
export const btnCls = "inline-flex items-center gap-1.5 rounded-lg bg-slate-900 text-white text-xs px-3 py-2 disabled:opacity-40 transition-opacity hover:bg-slate-800";
export const ghostCls = "inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white text-slate-700 text-xs px-3 py-2 disabled:opacity-40 hover:border-slate-300 transition-colors";
